import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export function EmailValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim();
  return !value || Validators.email({ ...control, value } as any) === null
    ? null
    : { email: true };
}
